exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".deliveryMobBox[data-v-a8f473c0]{display:none}@media(max-width:767px){.deliveryMobBox[data-v-a8f473c0]{margin-top:-50px;background-color:#fff;padding:10px 24px 80px;display:flex;align-items:flex-start;justify-content:space-between}.deliveryMobBox .text-wrap[data-v-a8f473c0]{display:flex;align-items:flex-start;flex-wrap:wrap;width:calc(50% - 15px);text-align:center}.deliveryMobBox .text-wrap img[data-v-a8f473c0]{width:26px;min-width:26px;height:26px;margin:0 auto 16px}.deliveryMobBox .text-wrap .fs-14[data-v-a8f473c0]{width:100%;line-height:1.5}.deliveryMobBox .text-wrap .fs-14 strong[data-v-a8f473c0]{display:block}}", ""]);

// exports
